import React from "react";
import { DatabasesViewWrap } from "./DatabasesViewWrap";

const DatabasesReactView = () => {
  return <DatabasesViewWrap />;
};

window.DatabasesReactView = DatabasesReactView;
